/**
 * Zeile „Antwortet mit …“ in der Entwicklungs-Tafel unter dem Kopf. (19.10.2026)
 *
 * Martin: Wer in den Einstellungen oder auf einer anderen Seite auf „Entwicklung“ tippt, sah das Modell nicht — nur im Chat
 * steht es als Chip im Eingabefeld.
 *
 * ⚠️ KEINE zweite Quelle: Die Zeile spiegelt, was die Chips #status-llm (Modell) und #status-tiefe (Antwortlänge) gerade
 * zeigen. Diese Chips bleiben im DOM, auch wenn eine andere Seite offen ist; ihre Texte setzen renderStatusBar und
 * updateFooterEffectiveModel (app.ts). Ein Beobachter zieht jede Änderung nach, es gibt keinen eigenen Zustand.
 * Geändert wird nur dort (Chip im Chat, Einstellungen) — die Zeile ist reine Anzeige.
 */
const ZEILE_ID = "topbar-entwicklung-modell";
const WERT_ID = "topbar-entwicklung-modell-wert";
const CHIP_MODELL_ID = "status-llm";
const CHIP_TIEFE_ID = "status-tiefe";
const NOCH_UNBEKANNT = "wird ermittelt";

const beobachtet = new WeakSet<Element>();

/** „Opus 5.5 · Abo · Normal“; ohne Modell-Chip oder bei „…“ ein ehrlicher Platzhalter. */
export function modellText(doc: Document): string {
  const roh = doc.getElementById(CHIP_MODELL_ID)?.textContent?.trim() ?? "";
  const modell = roh === "" || roh === "…" ? NOCH_UNBEKANNT : roh;
  const laenge = doc.getElementById(CHIP_TIEFE_ID)?.querySelector(".composer-tiefe-wort")?.textContent?.trim() ?? "";
  return laenge ? `${modell} · ${laenge}` : modell;
}

/** Schreibt den Text in die Tafel. Ohne die Zeile (andere Seite) passiert nichts. */
export function zeigeEntwicklungModell(doc: Document = document): void {
  const wert = doc.getElementById(WERT_ID);
  if (!wert) return;
  const text = modellText(doc);
  if (wert.textContent !== text) wert.textContent = text;
  const zeile = doc.getElementById(ZEILE_ID);
  const fallback = doc.getElementById(CHIP_MODELL_ID)?.dataset.fallback === "1";
  if (zeile) {
    if (fallback) zeile.dataset.fallback = "1";
    else delete zeile.dataset.fallback;
  }
}

/** Zeichnet jetzt und danach bei jeder Änderung der beiden Chips neu. Jeder Chip wird nur einmal beobachtet. */
export function beobachteEntwicklungModell(doc: Document = document): void {
  zeigeEntwicklungModell(doc);
  const Beobachter = doc.defaultView?.MutationObserver ?? globalThis.MutationObserver;
  if (!Beobachter) return;
  for (const id of [CHIP_MODELL_ID, CHIP_TIEFE_ID]) {
    const chip = doc.getElementById(id);
    if (!chip || beobachtet.has(chip)) continue;
    beobachtet.add(chip);
    new Beobachter(() => zeigeEntwicklungModell(doc)).observe(chip, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
    });
  }
}
